import axios from "axios";
import { decryptString, encryptString } from "../helpers/utility";

// Create an axios instance
const instance = axios.create({
  baseURL: window.Configs.base_url,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
    "Cache-Control": "no-cache",
    Pragma: "no-cache",
    Expires: "-1",
  },
});

// // Add request interceptor to encrypt data
// instance.interceptors.request.use(
//   (config) => {
//     if (config.data) {
//       // Encrypt the request payload
//       config.data = encryptString(config.data);
//     }
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

// // Add response interceptor to decrypt data
// instance.interceptors.response.use(
//   (response) => {
//     if (response.data) {
//       // Decrypt the response data
//       response.data = decryptString(response.data);
//     }
//     return response;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

export default instance;
